<template>
<AdminPanelEGiftsShoppingPacket />
</template>

<script>
import AdminPanelEGiftsShoppingPacket from '../components/AdminPanelEGiftsShoppingPacket.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEGiftsShoppingPacket
    },
    methods: {},
    mounted() {}
}
</script>